import { useState } from "react";
import Icons from "../../myIcon/Icons";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";

export default function HomeManufacture() {
    const [activeKey, setActiveKey] = useState("year-tab1");

  return (
    <>
    <div className="home-manufac">
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <div className="homemanufac-head">
                        <h3 className="heading">production unit</h3>

                        <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
                            <div className="homemanufac-tab">
                                <Nav className="manufac-link">
                                    <Nav.Item>
                                        <Nav.Link eventKey="year-tab1" onMouseEnter={() => setActiveKey("year-tab1")}>Architects <Icons name="Longarrow_right"/></Nav.Link>
                                    </Nav.Item>

                                    <Nav.Item>
                                        <Nav.Link eventKey="year-tab2" onMouseEnter={() => setActiveKey("year-tab2")}>Developers <Icons name="Longarrow_right"/></Nav.Link>
                                    </Nav.Item>

                                    <Nav.Item>
                                        <Nav.Link eventKey="year-tab3" onMouseEnter={() => setActiveKey("year-tab3")}>Homeowners <Icons name="Longarrow_right"/></Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                <Tab.Content className="manufac-content wow animate__animated animate__slideInRight" data-wow-duration="1s" data-wow-delay="0.1s">
                                    <Tab.Pane eventKey="year-tab1">
                                        <p>We collaborate with architects to translate visionary concepts into flawless spaces, combining precise craftsmanship, premium materials, and detailing that brings creative ideas to life with perfection.</p>
                                        <div className="text-right">
                                            <Link to="/contact" className="arrow-button">Let’s Talk <Icons name="Longarrow_right"/></Link>
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="year-tab2">
                                        <p>We partner with developers to craft interiors that elevate every project, delivering quality, consistency, and value while enhancing the overall appeal and long-term market potential.</p>
                                        <div className="text-right">
                                            <Link to="/contact" className="arrow-button">Let’s Talk <Icons name="Longarrow_right"/></Link>
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="year-tab3">
                                        <p>We help homeowners transform houses into personalized sanctuaries, offering bespoke interiors tailored to lifestyle, taste, and comfort with timeless designs that reflect individuality and elegance.</p>
                                        <div className="text-right">
                                            <Link to="/contact" className="arrow-button">Let’s Talk <Icons name="Longarrow_right"/></Link>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div> 
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
